import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/auth/callback/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <div>Hello /auth/callback!</div>;
}
